import { useState, useRef } from 'react';

export const ExpandableContent = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef(null);

  const toggleContent = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="expandable-container card bg-white shadow-md rounded-xl p-4 mt-4">
      <button 
        className="expandable-header"
        onClick={toggleContent}
        aria-expanded={isExpanded}
        aria-controls="expandable-content"
      >
        <span >{title}</span>
        <span className="arrow-icon transition-transform duration-300 inline-block"
  style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          ▼
        </span>
      </button>

      <div
        id="expandable-content"
        className="expandable-content"
        style={{
          maxHeight: isExpanded ? `${contentRef.current?.scrollHeight}px` : '0px',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out'
        }}
      >
        <div ref={contentRef} className="content-wrapper">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ExpandableContent;